/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
import React, { useCallback, useState } from 'react';
import { Text, View, StyleSheet, TouchableOpacity, TextInput } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import WarningIcon from '../assets/svg/warningIcon';
import CloseIcon from '../assets/svg/CloseIcon';
import db from '../utils/db';

const styles = StyleSheet.create({
  container: {
    marginTop: 0,
    marginLeft: 56,
    marginRight: 56,
    height: 766,
    backgroundColor: '#fff',
    marginBottom: 60,
    width: 1328,
    alignSelf: 'center',
  },
  title: {
    fontSize: 20,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
  },
  titleContainer: {
    marginTop: 47,
    marginLeft: 302,
    marginRight: 302,
    height: 28,
    width: 724,
  },
  warning1Container: {
    marginLeft: 260,
    marginRight: 260,
    marginTop: 27,
    width: 808,
    flexDirection: 'row',
    height: 84,
  },
  warning1Icon: {
    width: 26,
    marginRight: 16,
  },
  warning1Text: {
    fontSize: 20,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
    width: 766,
  },
  warning1Info: {
    backgroundColor: '#555559',
    width: 81,
    height: 20,
    right: 377,
    top: 60,
    position: 'absolute',
  },
  warning1InfoText: {
    fontSize: 12,
    fontFamily: 'PingFangSC-Semibold',
    marginTop: 2,
    marginBottom: 1,
    height: 17,
    justifyContent: 'center',
    alignSelf: 'center',
    textAlign: 'center',
    color: '#fff',
  },
  warning2Container: {
    marginLeft: 260,
    marginRight: 260,
    marginTop: 24,
    width: 808,
    flexDirection: 'row',
    height: 28,
  },
  warning2Icon: {
    width: 26,
    marginRight: 16,
  },
  warning2Text: {
    fontSize: 20,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
    width: 766,
  },
  warning2Info: {
    backgroundColor: '#555559',
    width: 81,
    height: 20,
    position: 'absolute',
    top: 4,
    right: 56,
  },
  warning2InfoText: {
    fontSize: 12,
    fontFamily: 'PingFangSC-Semibold',
    marginTop: 2,
    marginBottom: 1,
    height: 17,
    justifyContent: 'center',
    alignSelf: 'center',
    textAlign: 'center',
    color: '#fff',
  },
  listContainer: {
    width: 868,
    marginTop: 72,
    marginLeft: 230,
    marginRight: 230,
  },
  listHeader: {
    height: 49,
    flexDirection: 'row',
  },
  listHeaderCurrency: {
    height: 49,
    width: 196,
    marginRight: 4,
    backgroundColor: '#efefef',
  },
  textCurrency: {
    fontSize: 20,
    color: '#979797',
    height: 28,
    marginTop: 12,
    marginBottom: 9,
    marginLeft: 60,
    marginRight: 50,
    textAlign: 'center',
    fontFamily: 'PingFangSC-Semibold',
  },
  listHeaderAddress: {
    height: 49,
    width: 668,
    backgroundColor: '#efefef',
  },
  textAddress: {
    fontSize: 20,
    color: '#979797',
    height: 28,
    marginTop: 12,
    marginBottom: 9,
    marginLeft: 271,
    marginRight: 379,
    textAlign: 'center',
    width: 78,
    fontFamily: 'PingFangSC-Semibold',
  },
  listContent: {
    height: 28,
    flexDirection: 'row',
    marginTop: 24,
  },
  textContentCurrency: {
    fontFamily: 'PingFangSC-Semibold',
    color: '#132c32',
    marginLeft: 68,
    marginRight: 102,
    fontSize: 20,
    width: 61,
  },
  textConetentAddress: {
    fontFamily: 'PingFangSC-Semibold',
    color: '#132c32',
    fontSize: 20,
    width: 535,
  },
  copyButton: {
    height: 28,
    width: 86,
    marginLeft: 16,
    backgroundColor: '#247a9c',
  },
  copyText: {
    height: 22,
    textAlign: 'center',
    marginVertical: 3,
    marginHorizontal: 23,
    justifyContent: 'center',
    fontFamily: 'PingFangSC-Semibold',
    color: '#fff',
  },
  devideLine: {
    height: 1,
    width: 868,
    marginRight: 230,
    marginTop: 24,
    backgroundColor: '#efefef',
  },
  depositButtonContainer: {
    width: 436,
    height: 68,
    marginTop: 87,
    marginLeft: 446,
    marginRight: 446,
  },
  depositButtonBackground: {
    width: '100%',
    height: '100%',
  },
  depositButtonText: {
    fontSize: 26,
    fontFamily: 'PingFangSC-Medium',
    color: '#fff',
    alignSelf: 'center',
    marginTop: 16,
  },
  popupContainer: {
    backgroundColor: '#000000aa',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
  },
  popupbox: {
    alignSelf: 'center',
    justifyContent: 'center',
    height: 400,
    width: 800,
    backgroundColor: '#fff',
  },
  popupCloseIcon: {
    top: 6,
    right: 6,
    height: 25,
    width: 25,
    position: 'absolute',
  },
  confirmContainer: {
    width: 436,
    height: 68,
    marginTop: 87,
    marginLeft: 182,
    marginRight: 182,
  },
  confirmBackground: {
    width: '100%',
    height: '100%',
  },
  confirmText: {
    fontSize: 26,
    fontFamily: 'PingFangSC-Medium',
    color: '#fff',
    alignSelf: 'center',
    marginTop: 16,
  },
  amountInputPlaceholder: {
    paddingLeft: 26,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 16,
    marginBottom: 10,
  },
  amountInput: {
    paddingLeft: 26,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 22,
    marginBottom: 5,
    color: '#595959',
  },
  amountInputFrame: {
    borderBottomColor: '#555559',
    borderBottomWidth: 2,
    width: 464,
    justifyContent: 'flex-end',
  },
  amountInputText: {
    textAlign: 'right',
    fontSize: 26,
    color: '#132c32',
    marginRight: 37,
    fontFamily: 'PingFangSC-Semibold',
  },
  amountInputContainer: {
    flexDirection: 'row',
    marginTop: 106,
    marginRight: 25,
    justifyContent: 'flex-end',
    height: 37,
  },
});

const DepositScreen = React.memo(() => {
  const [isPopupVisible, setPopupVisible] = useState(false);

  const handleMoreInfo = useCallback(() => {
    window.open('https://www.google.com/', '_blank');
  }, []);

  const handleCopy = useCallback(() => {
    const { navigator } = window;
    navigator.clipboard.writeText('0xdd2c45b296C218779783c9AAF9f876783c9AAF9f876');
  }, []);

  const handlePress = useCallback(() => {
    setPopupVisible(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setPopupVisible(false);
  }, []);

  const Popup = () => {
    const [amount, setAmount] = useState('');
    const handleAmount = useCallback((text: string) => {
      setAmount(Number(text.replace(/\D/g, '')).toLocaleString('en'));
    }, []);
    const handleConfirm = useCallback(() => {
      // eslint-disable-next-line no-console
      console.log(Number(amount.replace(/\D/g, '')) + 1);
      async function fetch() {
        const address = '0xdd2c45b296C218779783c9AAF9f876783c9AAF9f876';
        const docRef = doc(db, 'user', 'user');
        const docSnap = await getDoc(docRef);
        const docRefTwdc = doc(db, 'twdc', 'twdc');
        const docSnapTwdc = await getDoc(docRefTwdc);

        if (docSnap.exists()) {
          const { balance } = docSnap.data();
          await updateDoc(docRef, {
            balance: balance + Number(amount.replace(/\D/g, '')),
          });
          // @ts-ignore
          const { supply } = docSnapTwdc.data();
          await updateDoc(docRefTwdc, {
            supply: supply - Number(amount.replace(/\D/g, '')),
          });
          console.log(`Deposit ${amount} TWDC to ${address}`);
          const date = new Date();
          await setDoc(doc(db, 'activity', Date.now().toString()), {
            date: date.toLocaleString('tw', { year: 'numeric', month: '2-digit', day: '2-digit' }),
            description: `Deposit ${amount} TWDC to`,
            address,
            amount: `${amount} TWDC`,
            status: 'Completed',
            timestamp: Date.now().toString(),
          });
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!');
        }
      }
      fetch();
      setPopupVisible(false);
    }, [amount]);
    return (
      <View style={styles.popupContainer}>
        <View style={styles.popupbox}>
          <TouchableOpacity style={styles.popupCloseIcon} onPress={handleClosePopup}>
            <CloseIcon />
          </TouchableOpacity>
          <View style={styles.amountInputContainer}>
            <Text style={styles.amountInputText}>Amount to Deposit:</Text>
            <View style={styles.amountInputFrame}>
              <TextInput
                placeholder="Amount to deposit"
                style={amount ? styles.amountInput : styles.amountInputPlaceholder}
                placeholderTextColor="#979797"
                value={amount}
                onChangeText={handleAmount}
              />
            </View>
          </View>
          <TouchableOpacity style={styles.confirmContainer} onPress={handleConfirm}>
            <LinearGradient
              colors={['#03ae9d', '#45459b']}
              start={{
                x: 0,
                y: 0,
              }}
              end={{
                x: 1,
                y: 1,
              }}
              style={styles.confirmBackground}
            >
              <Text style={styles.confirmText}>Confirm</Text>
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </View>
    );
  };
  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>Plrease use one of the following address to deposit TWDC to your account.</Text>
      </View>
      <View style={styles.warning1Container}>
        <WarningIcon style={styles.warning1Icon} />
        <Text style={styles.warning1Text}>
          The minimum redeemable amount is 100,000 TWDC. Please deposit an amount <br />
          equal or greater than minimum required otherwise you will not be able to <br />
          redeem the deposited amount.{' '}
        </Text>
        <TouchableOpacity style={styles.warning1Info} onPress={handleMoreInfo}>
          <Text style={styles.warning1InfoText}>More info</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.warning2Container}>
        <WarningIcon style={styles.warning2Icon} />
        <Text style={styles.warning2Text}>The following address accept the specified TWDC deposits only. </Text>
        <TouchableOpacity style={styles.warning2Info} onPress={handleMoreInfo}>
          <Text style={styles.warning2InfoText}>More info</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.listContainer}>
        <View style={styles.listHeader}>
          <View style={styles.listHeaderCurrency}>
            <Text style={styles.textCurrency}>Currency</Text>
          </View>
          <View style={styles.listHeaderAddress}>
            <Text style={styles.textAddress}>Address</Text>
          </View>
        </View>
        <View style={styles.listContent}>
          <Text style={styles.textContentCurrency}>TWDC</Text>
          <Text style={styles.textConetentAddress}>0xdd2c45b296C218779783c9AAF9f876783c9AAF9f876</Text>
          <TouchableOpacity style={styles.copyButton} onPress={handleCopy}>
            <Text style={styles.copyText}>Copy</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.devideLine} />
        <View style={styles.listContent}>
          <Text style={styles.textContentCurrency}>TWDC</Text>
          <Text style={styles.textConetentAddress}>0xdd2c45b296C218779783c9AAF9f876783c9AAF9f876</Text>
          <TouchableOpacity style={styles.copyButton} onPress={handleCopy}>
            <Text style={styles.copyText}>Copy</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.devideLine} />
      </View>
      <TouchableOpacity style={styles.depositButtonContainer} onPress={handlePress}>
        <LinearGradient
          colors={['#03ae9d', '#45459b']}
          start={{
            x: 0,
            y: 0,
          }}
          end={{
            x: 1,
            y: 1,
          }}
          style={styles.depositButtonBackground}
        >
          <Text style={styles.depositButtonText}>Deposit</Text>
        </LinearGradient>
      </TouchableOpacity>
      {isPopupVisible ? <Popup /> : <View />}
    </View>
  );
});

export default DepositScreen;
